import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE,
         GET_PROFILE, GET_PROFILE_SUCCESS, GET_PROFILE_ERROR} from "./actionTypes"
import { LOGOUT_USER } from "../login/actionTypes"

const initialState = {
  user: "",         // was ""
  status: "idle",     // idle | loading | ready | missing | error
  error: null,
  success: "",
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      state = { ...state, status: "loading", error: null }
      break

    case GET_PROFILE_SUCCESS:
      state = { ...state, user: action.payload, status: "ready", error: null }
      break

    case GET_PROFILE_ERROR:
      // If we purposely detect "missing profile", we will send { code: "PROFILE_MISSING" }
      if (action.payload?.code === "PROFILE_MISSING") {
        state = { ...state, user: null, status: "missing", error: action.payload }
      } else {
        state = { ...state, user: null, status: "error", error: action.payload }
      }
      break
    // Without this the previous user's profile survives logout, so the next
    // login renders against their data until something happens to refetch.
    case LOGOUT_USER:
      state = { ...initialState }
      break
    case EDIT_PROFILE:
      state = { ...state }
      break
    case PROFILE_SUCCESS:
      state = { ...state, user: action.payload.profile, status: "ready", error: null }
      break
    case PROFILE_ERROR:
      state = { ...state, status: "error", error: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
